import {showCreateStocktakeModal} from './Modals/CreateStocktakeModal.js'

export default function Actions() {
  return (
    <>
      <li className="inline-block v-align-middle fs-n0 divider--left">
        <button
          className="btn btn--action v-align-base"
          type="button"
          onClick={() => showCreateStocktakeModal()}
        >
          Initiate a Stocktake
        </button>
      </li>
    </>
  )
}
